import menu from "./lib/menu";
import animadoAlAparecer from "./lib/animado-al-aparecer";
import formulario from "./lib/formulario";
import bloques from "./ilhoga/bloques";
import galeria from "./ilhoga/galeria";
import clicks from "./ilhoga/clicks";
import popup from "./ilhoga/popup";
import testimonios from "./ilhoga/testimonios";

require('../sass/app.scss');

const ajustaVw = () => {
    document.documentElement.style.setProperty('--vw', `${document.documentElement.clientWidth}px`);
};

export interface IDataLayer {
    push: Function
}

const dataLayer = (window as any).dataLayer as IDataLayer;

addEventListener('resize', ajustaVw);
addEventListener('load', ajustaVw);
ajustaVw();
menu();
formulario('form', {
    dataLayer,
    offset: () => document.querySelector('.cabeceraPrincipal')!.getBoundingClientRect().bottom,
});
const animado = animadoAlAparecer('.animado');
bloques(animado.actualiza);
animado.actualiza();
galeria();
clicks();
popup();
testimonios();

export {};